import { SidebarContext } from "@components:Sidebar/Sidebar.Context";
import { Box, List, ListSubheader, SxProps } from "@mui/material";
import { ReactNode, useContext } from "react";

export interface SidebarMenuProps {
  children: ReactNode;
  subHeading?: string;
  sx?: SxProps;
  hidden?: boolean;
}

export const SidebarMenu = ({
  children,
  subHeading = "menu",
  sx,
  hidden,
}: SidebarMenuProps) => {
  const sidebarContext = useContext(SidebarContext);

  if (hidden) {
    return null;
  }

  return (
    <Box
      sx={{
        ...sx,
      }}
      className="Sidebar__Menu"
    >
      <List
        className="Sidebar__Menu__List"
        component="nav"
        subheader={
          <ListSubheader
            className="Sidebar__Menu__Subheader"
            component="div"
            sx={{
              backgroundColor: "transparent",
              paddingY: "3px",
              color: sidebarContext.subHeaderTextColor,
              paddingX: "0px",
              lineHeight: "20px",
              fontWeight: "bold",
              fontSize: "10px",
            }}
          >
            {!sidebarContext.isCollapse ? subHeading : "..."}
          </ListSubheader>
        }
      >
        {children}
      </List>
    </Box>
  );
};
